const ProductCards = () => {
  const productCards = document.querySelectorAll('.product-card');

  const resetActiveSibling = (siblings) => {
    siblings.forEach(sibling => {
      sibling.classList.remove('active');
    });
  }

  if (productCards.length > 0) {
    productCards.forEach(productCard => {
      const productCardTitle = productCard.querySelector('.product-card-info .product-card-title');
      const productCardPrice = productCard.querySelector('.product-card-info .price ins .amount');
      const productCardFeaturedImage = productCard.querySelector('.product-primary-image');
      const productCardSecondImage = productCard.querySelector('.product-secondary-image');
      const productCardImageLink = productCard.querySelector('.product-card--featured-image-link');
      const quickView = productCard.querySelector('.product-card-quickview');

      const siblings = productCard.querySelectorAll('.sibling-item');
        
      productCard.addEventListener('mouseover', (e) => {
        const sibling = e.target.closest('.sibling-item');
        if (sibling && productCard.contains(sibling)) {
          const title = sibling.dataset.siblingTitle;
          const price = sibling.dataset.siblingPrice;
          const featuredImage = sibling.dataset.siblingImage;
          const secondaryImage = sibling.dataset.siblingSecondImage;
          const comparePrice = sibling.dataset.siblingComparePrice;
          const siblingUrl = sibling.href;
          const siblingHandle = sibling.dataset.siblingHandle;

          if(siblings.length > 0) {
            resetActiveSibling(siblings)
          }
          
          sibling.classList.add('active');

          if(productCardImageLink) {
            productCardImageLink.href = siblingUrl;
          }
          
          if(quickView) {
            quickView.dataset.productHandle = siblingHandle;
          }

          if(productCardTitle) {
            productCardTitle.innerText = title;
            productCardTitle.href = siblingUrl;
          }

          if(productCardPrice) {
            productCardPrice.innerText = price;
          }

          if(productCardFeaturedImage) {
            productCardFeaturedImage.src = featuredImage;
            productCardFeaturedImage.dataset.src = featuredImage;
            productCardFeaturedImage.alt = title;
            productCardFeaturedImage.srcset = featuredImage;
          }
          
          if(productCardSecondImage) {
            productCardSecondImage.src = secondaryImage;
            productCardSecondImage.dataset.src = secondaryImage;
            productCardSecondImage.alt = title;
            productCardSecondImage.srcset = secondaryImage;
          }
        }
      });
    });
  }
};

window.addEventListener('DOMContentLoaded', ProductCards);
